import pakageimg1 from '../assets/images/pakages-img-1.png'
import pakageimg2 from '../assets/images/pakages-img-2.png'
import pakageimg3 from '../assets/images/pakages-img-3.png'

const PakagesData = [
    {
        id:1,
        image:pakageimg1,
        pakagename:"Sugar Screen",
        age:"For Age : 18-80Yrs",
        prices:"₹699",
        cutprices:"(₹999)",  
        offer:"25% Off",
        nummbertest:"Include 3 Tests",
        btnfirst:"Read More",
        btnsecond:"Add to Cart"
    },
     {
        id:2,
        image:pakageimg2,
        pakagename:"Thyroid Assessment - Basic",
        age:"For Age : 18-80Yrs",
        prices:"₹699",
        cutprices:"(₹999)",
        offer:"25% Off",
        nummbertest:"Include 3 Tests",
        btnfirst:"Read More",
        btnsecond:"Add to Cart"
    },
     {
        id:3,
        image:pakageimg3,
        pakagename:"Annual Health Check-Up",
        age:"For Age : 18-80Yrs",
        prices:"₹699",
        cutprices:"(₹999)",
        offer:"25% Off",
        nummbertest:"Include 3 Tests",
        btnfirst:"Read More",
        btnsecond:"Add to Cart"
    },
    {
        id:4,
        image:pakageimg1,
        pakagename:"Sugar Screen",
        age:"For Age : 18-80Yrs",
        prices:"₹699",
        cutprices:"(₹999)",
        offer:"25% Off",
        nummbertest:"Include 3 Tests",
        btnfirst:"Read More",
        btnsecond:"Add to Cart"
    },
    {
        id:5,
        image:pakageimg1,
        pakagename:"Sugar Screen",
        age:"For Age : 18-80Yrs",
        prices:"₹699",
        cutprices:"(₹999)",
        offer:"25% Off",
        nummbertest:"Include 3 Tests",
        btnfirst:"Read More",
        btnsecond:"Add to Cart"
    },
    {
        id:6,
        image:pakageimg1,
        pakagename:"Sugar Screen",
        age:"For Age : 18-80Yrs",
        prices:"₹699",
        cutprices:"(₹999)",
        offer:"25% Off",
        nummbertest:"Include 3 Tests",
        btnfirst:"Read More",
        btnsecond:"Add to Cart"
    }
]

export default PakagesData;